<script>    
    import {createEventDispatcher } from 'svelte'
    import { language } from '../languages';
    import { deleteImage } from '../service'
    import PermissionCheck from './PermissionCheck.svelte';
    export let image 
    export let index = 0;
    let openDialog = false  
    const dispatch = createEventDispatcher()

    function handleDeleteImage(){
        deleteImage(image)
        .then(data => {
            openDialog = false
            dispatch('deleted', data)
        })
    }

    const baseUrl =  location.origin + location.pathname  ;
    

</script>
<style>
    img {
        width:100%;
        height: 100%;
    }
    .hidden {
        display: none;
    }
    .dialog {
        background:rgba(10,10,10,.6);     
    }

    .image-item {
        min-height: 250px;
        background-color: #fff;
    }
</style>
{#if image }
    <div class:hidden={!openDialog} 
        class="dialog absolute z-50 top-0 left-0 w-full  h-full  flex flex-col justify-center" id="imagelimit-dialog-box">    
        <div class="w-full bg-white my-3  p-8">
                <p class="p-4">
                    <span>Are you sure want to delete this image :</span>
                    <img  src="/uploads/{image.image}" alt="">                

                </p>
            <hr>
            <div class="flex flex-row justify-between gap-2">
                <button class="p-1 bg-gray-400 text-white w-full"
                    on:click={()=>{openDialog = false}}>NO </button>        
                <button class="p-1 bg-red-400 text-white w-full"
                    on:click={ handleDeleteImage}> YES </button>
            </div>
        </div>
    </div>
    <div class=" text-3xl border-2 rounded text-center bg-green-100 relative">
        <div class=" bg-white realtive">
            <div class="absolute z-20 flex flex-row justify-between w-full">
                <div style="width:50px;height:50px;background:rgba(10,10,10,.6);"
                    class="m-2 p-2 top-0 rounded-full text-center font-bold text-white text-lg">{ index + 1}</div>
                <PermissionCheck permissions={['STATION_IMAGE.DELETE']} resource_creator_id={image.created_by.id || null}>
                    <button style="background:rgba(3,3,3,.4);width:50px;height:50px;" 
                        class="p-2 m-2 rounded-full text-red-100 outeline-none"  on:click={()=>{openDialog=true}}>
                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="30" height="30" viewBox="0 0 100 100" >                                    
                            <path id="Trash" d="M81,23.5H61V17c0-1.1-0.9-2-2-2H41c-1.1,0-2,0.9-2,2v6.5H19c-1.1,0-2,0.9-2,2c0,1.1,0.9,2,2,2h6.6V83
                                c0,1.1,0.9,2,2,2h44.8c1.1,0,2-0.9,2-2V27.5H81c1.1,0,2-0.9,2-2C83,24.4,82.1,23.5,81,23.5z M43,19h14v4H43V19z M70.4,81H29.6V27.5
                                h40.8V81z M61,38.3v32c0,1.1-0.9,2-2,2s-2-0.9-2-2v-32c0-1.1,0.9-2,2-2S61,37.1,61,38.3z M43,38.3v32c0,1.1-0.9,2-2,2s-2-0.9-2-2
                                v-32c0-1.1,0.9-2,2-2S43,37.1,43,38.3z" file="currentColor" stroke="currentColor" stroke-width="3"/>                                   
                        </svg>
                    </button>                            

                </PermissionCheck>                
            </div>
        </div>
        <hr>        
        <div class="w-full h-full relative" >    
            <!-- <img src={ URL.createObjectURL(img.data)} alt=""> -->
            <img  class="image-item" src="/uploads/{image.image}" alt="">    
            <span class="z-40 block absolute bottom-0 text-sm p-2">
                {$language.label_uploaded_at }    {image.created_at}
            </span>
        </div>

    </div>
{/if}